(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oripik-home-styles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('.op-home a[href^="#op-"]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const target = document.getElementById(link.getAttribute('href').slice(1));
  if (!target) return;
  event.preventDefault();
  event.stopPropagation();
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
  target.scrollIntoView({ behavior: 'instant', block: 'start' });
}, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oripik-pack-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oripik-pack-summary')) {
  customElements.define('oripik-pack-summary', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.scope?.classList.add('op-pack-page');
      this.update = () => {
        const quantity = Number(this.scope?.querySelector('input[name="quantity"]')?.value || 1);
        const total = quantity * Number(this.dataset.count);
        this.querySelector('.op-pack-total').textContent = this.dataset.message.replace('__PACKS__', quantity).replace('__MOUNTS__', total);
      };
      this.scope?.addEventListener('change', this.update);
      this.scope?.addEventListener('input', this.update);
      this.update();
      this.refreshTimer = setTimeout(this.update, 150);
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.update);
      this.scope?.removeEventListener('input', this.update);
      clearTimeout(this.refreshTimer);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
